// extracted by mini-css-extract-plugin
export default {"healthInfoForm":"HealthInfo_healthInfoForm__qCVMV","formBody":"HealthInfo_formBody__atiZJ","select":"HealthInfo_select__vM5lG","submitButton":"HealthInfo_submitButton__wYO0E"};